module.exports = __webpack_public_path__ + "img/haekchen.7a0253d7.svg";